// Portado de src/components/tratamento/Dores.astro (site Astro).
export interface DoresItem {
  icone: string;
  titulo: string;
  texto: string;
}

export interface DoresProps {
  sobretitulo: string;
  titulo: string;
  chamada: string;
  itens: DoresItem[];
}

export function Dores({ sobretitulo, titulo, chamada, itens }: DoresProps) {
  return (
    <section className="dores">
      <div className="container">
        <div className="dores-topo">
          <p className="dores-eyebrow">{sobretitulo}</p>
          <h2>{titulo}</h2>
          <p className="dores-chamada">{chamada}</p>
        </div>
        <ol className="fatores">
          {itens.map((f, i) => (
            <li className="fator" key={i}>
              <span className="fator-n">{String(i + 1).padStart(2, "0")}</span>
              <span className="fator-icone">
                <img src={f.icone} width={24} height={24} alt="" loading="lazy" />
              </span>
              <div className="fator-texto">
                <h3>{f.titulo}</h3>
                <p>{f.texto}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
